import { Box, Tag } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildMySurveysDataTableFilter,
  useMySurveysDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

type FilterOption = {
  label: string
  value: boolean
  component: JSX.Element
}
export const statusFilter = (source: ReturnType<typeof useMySurveysDataTable>) => {
  const options: FilterOption[] = [
    {
      label: i18n.t('trainings.my_surveys.datatable.status.pending'),
      value: false,
      component: (
        <Box width="fit-content">
          <Tag leftItem="circle" type="tangerine" showCircle ellipsis>
            {i18n.t('trainings.my_surveys.datatable.status.pending')}
          </Tag>
        </Box>
      ),
    },
    {
      label: i18n.t('trainings.my_surveys.datatable.status.completed'),
      value: true,
      component: (
        <Box width="fit-content">
          <Tag leftItem="circle" type="lime" showCircle ellipsis>
            {i18n.t('trainings.my_surveys.datatable.status.completed')}
          </Tag>
        </Box>
      ),
    },
  ]
  return buildMySurveysDataTableFilter(source, {
    type: FilterType.Boolean,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'statusFilter',
    path: 'answerCount',
    title: i18n.t('trainings.my_surveys.datatable.filters.status'),
  })
}
